define([
	"jquery",
	"underscore",
	"marionette",
], function($, _, Marionette) {
	return Marionette.View.extend({
		el: '#payment-root',

		behaviors: {

		},

		ui: {
			'qrCode':'#qr_code',
			'btnCancel': '#btn_cancel'
		},

		events: {
			'click @ui.btnCancel': 'cancelTransaction'
		},

		initialize: function(){
			this.bindUIElements();
			this.generateQRCode();
			console.log('bonjour');
			this.setSchedulers();
		},

		generateQRCode() {
			const QRCode = require('qrcode')
			const canvas = document.getElementById('qr_code')

			QRCode.toCanvas(canvas, window.qr_content);
		},

		setSchedulers() {
			const that = this;
			setInterval(() => {
				that.queryTransaction();
			}, 2000);
		},

		queryTransaction: function() {
			const that = this;
			$.ajax('/rest_deposit/query_transaction', {
				method: 'POST',
				data: {
					pay_method: window.pay_method,
					deposits_temp_cd: window.deposits_temp_cd
				},
				success: function(data) {
					const {code, message} = data;
					const {orderId, amount, state} = data.data;

					if(code != 105002) {
						that.redirectFail(message);
						return;
					}

					if(state == 'FAILED') {
						that.redirectFail();
						return;
					}

					if(state == 'PENDING') {
						// does nothing
						return;
					}

					// SUCCEEDED
					that.redirectSuccess();
				},
				error: function(model, error) {
					that.redirectFail();
				}
			})
		},

		redirectSuccess() {
			const successUrl = `${window.success_url}`;

			const form = $(`<form action="${successUrl}" method="post">` +
				`<input type="text" name="deposits_temp_cd" value="${window.deposits_temp_cd}" hidden/>` +
				'</form>');
			$('body').append(form);

			form.submit();
		},

		redirectFail(errorMessage = "Transaction Failed. Please contact to admin.") {
			const failUrl = `${window.fail_url}`;

			const form = $(`<form action="${failUrl}" method="post">` +
				`<input type="text" h name="deposits_temp_cd" value="${window.deposits_temp_cd}" hidden/>` +
				`<input type="text" name="error_message" value="${errorMessage}" hidden/>` +
				'</form>');
			$('body').append(form);

			form.submit();
		},

		cancelTransaction: function(e) {
			console.log('clicked');
			console.log(e);
			if(e)
			{
				e.preventDefault();
			}

			const that = this;
			$.ajax('/rest_deposit/cancel_transaction', {
				method: 'POST',
				data: {
					pay_method: window.pay_method,
					deposits_temp_cd: window.deposits_temp_cd
				},
				success: function(data) {
					const {code, message} = data;
					that.redirectFail(message)
				},
				error: function(model, error) {
					that.redirectFail();
				}
			})
		}
	});
});
